
.loader {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 400px;
  justify-content: center;
  margin: 0 auto;
  width: 300px;
  opacity: 0;
  animation: fadeIn 1s ease-out forwards;
  transform: translateY(10px);

  :not(.EMBEDED) > & {
    margin-top: 100px;
    height: 50vh;
  }

  .layout-padding {
    margin-top:90px;
  }

  &__img {
    margin-bottom:30px;
    width: 46px;
  }

  .progress-bar {
    height: 7px;
    width: 200px;

    &__bg {
      background-color: $gray-whitish;
      background-color: var(--gray-whitish);
      border-radius: 3.42px;
      height: 100%;
      width: 100%;
    }

    &__loader {
      animation: progress-bar 1s cubic-bezier(.17,.67,.83,.67);
      background: $main-color;
      background: var(--main-color);
      border-radius: 4px;
      height: 100%;
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
}
